import React from "react";
import { Link, useLocation } from "react-router-dom";
import JsonData from "../data/data.json";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
import { useEffect } from "react";
import { usePrecios } from "../hooks/usePrecios";

const euros = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export default function EscuelaHipica() {
  const location = useLocation();
  const { precios, error: preciosError } = usePrecios();
  const escuela = JsonData.EscuelaHipica || {};
  const grupos = precios?.Tarifas || [];

   useEffect(() => {
    if (!location.hash) return;
    const el = document.querySelector(location.hash);
    if (!el) return;

    const NAVBAR_HEIGHT = 80;
    const y = el.getBoundingClientRect().top + window.pageYOffset - NAVBAR_HEIGHT;

    window.scrollTo({ top: y, behavior: "smooth" });
  }, [location.hash]);

  return (
    <div className="container" style={{ paddingTop: 0, paddingBottom: 60 }}>
      <Seo
        title="Escuela Hípica | Clases para niños y adultos"
        description="Clases de equitación por niveles: iniciación a perfeccionamiento. Profesores titulados y caballos de escuela."
        path="/escuela-hipica"
        image="https://madridcampogrande.es/og/default.jpg"
      />
      <BreadcrumbLd
        items={[
          { name: "Inicio", path: "/" },
          { name: "Escuela hípica", path: "/escuela-hipica" },
        ]}
      />

      {/* ---- Bloque Escuela Hípica (encima de tarifas) ---- */}
      <section id="escuela-hipica" style={{ marginBottom: 40 }}>
        <h1 className="text-center" style={{ marginBottom: 20 }}>
          {escuela.titulo || "Escuela Hípica"}
        </h1>

        {Array.isArray(escuela.intro) &&
          escuela.intro.map((p, i) => (
            <p key={i} style={{ lineHeight: 1.7 }}>
              {p}
            </p>
          ))}

        {Array.isArray(escuela.imagenes) && escuela.imagenes.length > 0 && (
          <div className="row" style={{ marginTop: 20 }}>
            {escuela.imagenes.map((src, i) => (
              <div className="col-sm-6" key={i} style={{ marginBottom: 20 }}>
                <img
                  src={src}
                  alt={`Escuela Hípica ${i + 1}`}
                  className="img-responsive"
                />
              </div>
            ))}
          </div>
        )}
      </section>

      {/* ---- Tarifa ---- */}
      <section id="tarifas">
      <h2 className="text-center" style={{ margin: "10px 0 30px" }}>
        Tarifas
      </h2>

      <div style={{ marginBottom: 10 }}>
        Las tarifas de las clases se estructuran mediante bonos, de modo que si
        compras un bono luego podrás utilizarlo de la forma que tú elijas.
      </div>

      {preciosError && (
        <div className="alert alert-warning">
          No se han podido cargar las tarifas en este momento.
        </div>
      )}

      {!precios && !preciosError && <p>Cargando tarifas...</p>}

      {grupos.map((g, idx) => (
        <div
          key={idx}
          className="panel panel-default"
          style={{ marginBottom: 25 }}
        >
          <div
            className="panel-heading"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <strong>{g.nombre}</strong>
            <span className="text-muted">Duración {g.duracion}</span>
          </div>

          <div className="table-responsive">
            <table className="table table-striped" style={{ margin: 0 }}>
              <thead>
                <tr>
                  <th style={{ width: "70%" }}>Modalidad</th>
                  <th style={{ width: "30%", textAlign: "right" }}>Precio</th>
                </tr>
              </thead>
              <tbody>
                {g.ofertas.map((o, i) => (
                  <tr key={i}>
                    <td>{o.tipo}</td>
                    <td style={{ textAlign: "right" }}>{euros(o.precio)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      {/* Asterisco */}
      <p className="text-muted" style={{ marginTop: 10 }}>
        * Todos los bonos son trimestrales exceptuando los bonos particulares
        que son mensuales.
      </p>
      

      {/* Resto de notas */}
      <div style={{ marginTop: 20, lineHeight: 1.6 }}>
        <p>
          Otras actividades que tenemos son las{" "}
          <strong>salidas al campo</strong>. En este caso la tarifa se adaptará
          al recorrido, duración y características que mejor te vengan.
        </p>

        <div style={{ margin: "30px 0", textAlign: "center" }}>
          <img
            src={"/img/portfolio/ruta-1.jpeg"}
            alt={ "Ruta a caballo - 1"}
            style={{ width: "20%", height: "auto" }}
            className="img-responsive img-thumbnail"
          />
        </div>

        <p>
          Si quieres celebrar con nosotros tu <strong>cumpleaños</strong>, será
          un día inolvidable. Consulta la sección de{" "}
          <Link to="/cumpleanos">cumpleaños</Link>.
        </p>
      </div>
    </section>
    </div>
  );
}
